import validator from 'validator';
import { IsValidReactNode } from '../../Utility/ReactUtils';
export const ConfigurationTransformer = {
    // Argument Provided
    contains: (config) => (value) => validator['contains'](value, getConfigRuleValue(config)),
    equals: (config) => (value) => validator.contains(value, getConfigRuleValue(config)),
    isAfter: (config) => (value) => validator.isAfter(value, getConfigRuleValue(config)),
    isBefore: (config) => (value) => validator.isBefore(value, getConfigRuleValue(config)),
    isDivisibleBy: (config) => (value) => validator.isDivisibleBy(value, getConfigRuleValue(config)),
    isIn: (config) => (value) => validator.isIn(value, getConfigRuleValue(config)),
    matches: (config) => (value) => validator.matches(value, getConfigRuleValue(config)),
    // No argument
    isAlpha: (config) => (value) => optionalRule(getConfigRuleValue(config), validator.isAlpha(value, getProperty('locale', config))),
    isAlphanumeric: (config) => (value) => validator.isAlphanumeric(value, getProperty('locale', config)),
    isAscii: (config) => (value) => optionalRule(getConfigRuleValue(config), validator.isAscii(value)),
    isBase32: (config) => (value) => optionalRule(getConfigRuleValue(config), validator.isBase32(value)),
    isBase64: (config) => (value) => optionalRule(getConfigRuleValue(config), validator.isBase64(value, getProperty('options', config))),
    isIBAN: (config) => (value) => optionalRule(getConfigRuleValue(config), validator.isIBAN(value)),
    isBIC: (config) => (value) => optionalRule(getConfigRuleValue(config), validator.isBIC(value)),
    isBoolean: (config) => (value) => optionalRule(getConfigRuleValue(config), validator.isBoolean(value)),
    isByteLength: (config) => (value) => optionalRule(getConfigRuleValue(config), validator.isByteLength(value, getProperty('options', config))),
    isCreditCard: (config) => (value) => optionalRule(getConfigRuleValue(config), validator.isCreditCard(value)),
    isCurrency: (config) => (value) => optionalRule(getConfigRuleValue(config), validator.isCurrency(value, getProperty('options', config))),
    isEthereumAddress: (config) => (value) => optionalRule(getConfigRuleValue(config), validator.isEthereumAddress(value)),
    isBtcAddress: (config) => (value) => optionalRule(getConfigRuleValue(config), validator.isBtcAddress(value)),
    isDataURI: (config) => (value) => optionalRule(getConfigRuleValue(config), validator.isDataURI(value)),
    isDate: (config) => (value) => optionalRule(getConfigRuleValue(config), validator.isDate(value, getProperty('options', config))),
    isDecimal: (config) => (value) => optionalRule(getConfigRuleValue(config), validator.isDecimal(value, getProperty('options', config))),
    isEmail: (config) => (value) => optionalRule(getConfigRuleValue(config), validator.isEmail(value, getProperty('options', config))),
    isEmpty: (config) => (value) => optionalRule(getConfigRuleValue(config), validator.isEmpty(value, getProperty('options', config))),
    isFloat: (config) => (value) => optionalRule(getConfigRuleValue(config), validator.isFloat(value, getProperty('options', config))),
    isFQDN: (config) => (value) => optionalRule(getConfigRuleValue(config), validator.isFQDN(value, getProperty('options', config))),
    isFullWidth: (config) => (value) => optionalRule(getConfigRuleValue(config), validator.isFullWidth(value)),
    isHalfWidth: (config) => (value) => optionalRule(getConfigRuleValue(config), validator.isHalfWidth(value)),
    isHash: (config) => (value) => optionalRule(getConfigRuleValue(config), validator.isHash(value, getProperty('algorithm', config))),
    isHexadecimal: (config) => (value) => optionalRule(getConfigRuleValue(config), validator.isHexadecimal(value)),
    isHexColor: (config) => (value) => optionalRule(getConfigRuleValue(config), validator.isHexColor(value)),
    isHSL: (config) => (value) => optionalRule(getConfigRuleValue(config), validator.isHSL(value)),
    isRgbColor: (config) => (value) => optionalRule(getConfigRuleValue(config), validator.isRgbColor(value, getProperty('includePercentValues', config))),
    isIdentityCard: (config) => (value) => optionalRule(getConfigRuleValue(config), validator.isIdentityCard(value, getProperty('locale', config))),
    isInt: (config) => (value) => optionalRule(getConfigRuleValue(config), validator.isInt(value, getProperty('options', config))),
    isIP: (config) => (value) => optionalRule(getConfigRuleValue(config), validator.isIP(value, getProperty('version', config))),
    isIPRange: (config) => (value) => optionalRule(getConfigRuleValue(config), validator.isIPRange(value)),
    isISBN: (config) => (value) => optionalRule(getConfigRuleValue(config), validator.isISBN(value, getProperty('version', config))),
    isEAN: (config) => (value) => optionalRule(getConfigRuleValue(config), validator.isEAN(value)),
    isISIN: (config) => (value) => optionalRule(getConfigRuleValue(config), validator.isISIN(value)),
    isISO31661Alpha2: (config) => (value) => optionalRule(getConfigRuleValue(config), validator.isISO31661Alpha2(value)),
    isISO31661Alpha3: (config) => (value) => optionalRule(getConfigRuleValue(config), validator.isISO31661Alpha3(value)),
    isISO8601: (config) => (value) => optionalRule(getConfigRuleValue(config), validator.isISO8601(value, getProperty('options', config))),
    isISSN: (config) => (value) => optionalRule(getConfigRuleValue(config), validator.isISSN(value, getProperty('options', config))),
    isISRC: (config) => (value) => optionalRule(getConfigRuleValue(config), validator.isISRC(value)),
    isRFC3339: (config) => (value) => optionalRule(getConfigRuleValue(config), validator.isRFC3339(value)),
    isJSON: (config) => (value) => optionalRule(getConfigRuleValue(config), validator.isJSON(value)),
    isJWT: (config) => (value) => optionalRule(getConfigRuleValue(config), validator.isJWT(value)),
    isLatLong: (config) => (value) => optionalRule(getConfigRuleValue(config), validator.isLatLong(value)),
    isLength: (config) => (value) => optionalRule(getConfigRuleValue(config), validator.isLength(value, getProperty('options', config))),
    isLocale: (config) => (value) => optionalRule(getConfigRuleValue(config), validator.isLocale(value)),
    isLowercase: (config) => (value) => optionalRule(getConfigRuleValue(config), validator.isLowercase(value)),
    isMACAddress: (config) => (value) => optionalRule(getConfigRuleValue(config), validator.isMACAddress(value, getProperty('options', config))),
    isMagnetURI: (config) => (value) => optionalRule(getConfigRuleValue(config), validator.isMagnetURI(value)),
    isMD5: (config) => (value) => optionalRule(getConfigRuleValue(config), validator.isMD5(value)),
    isMimeType: (config) => (value) => optionalRule(getConfigRuleValue(config), validator.isMimeType(value)),
    isMongoId: (config) => (value) => optionalRule(getConfigRuleValue(config), validator.isMongoId(value)),
    isMultibyte: (config) => (value) => optionalRule(getConfigRuleValue(config), validator.isMultibyte(value)),
    isNumeric: (config) => (value) => optionalRule(getConfigRuleValue(config), validator.isNumeric(value, getProperty('options', config))),
    isOctal: (config) => (value) => optionalRule(getConfigRuleValue(config), validator.isOctal(value)),
    isPassportNumber: (config) => (value) => optionalRule(getConfigRuleValue(config), validator.isPassportNumber(value, getProperty('countryCode', config))),
    isPort: (config) => (value) => optionalRule(getConfigRuleValue(config), validator.isPort(value)),
    isPostalCode: (config) => (value) => optionalRule(getConfigRuleValue(config), validator.isPostalCode(value, getProperty('locale', config))),
    isSemVer: (config) => (value) => optionalRule(getConfigRuleValue(config), validator.isSemVer(value)),
    isStrongPassword: (config) => (value) => optionalRule(getConfigRuleValue(config), validator.isStrongPassword(value, getProperty('options', config))),
    isSurrogatePair: (config) => (value) => optionalRule(getConfigRuleValue(config), validator.isSurrogatePair(value)),
    isURL: (config) => (value) => optionalRule(getConfigRuleValue(config), validator.isURL(value, getProperty('options', config))),
    isUppercase: (config) => (value) => optionalRule(getConfigRuleValue(config), validator.isUppercase(value)),
    isUUID: (config) => (value) => optionalRule(getConfigRuleValue(config), validator.isUUID(value, getProperty('version', config))),
    isVariableWidth: (config) => (value) => optionalRule(getConfigRuleValue(config), validator.isVariableWidth(value)),
    isWhitelisted: (config) => (value) => optionalRule(getConfigRuleValue(config), validator.isWhitelisted(value, getProperty('chars', config))),
    isSlug: (config) => (value) => optionalRule(getConfigRuleValue(config), validator.isSlug(value)),
    toBoolean: (config) => (value) => optionalRule(getConfigRuleValue(config), validator.toBoolean(value, getProperty('strict', config))),
    custom: (config) => (value) => getConfigRuleValue(config)(value),
    required: (config) => (value) => optionalRule(getConfigRuleValue(config), value === '' || value === undefined || value === null ? false : true),
};
export const DefaultMessages = {
    required: 'Field is required',
    contains: 'Field is missing a required word',
    equals: 'Field does not match',
    isAfter: 'Error',
    isAlpha: 'Field must only contain letters',
    isAlphanumeric: 'Field must only contain letters and numbers',
    isAscii: 'Field must be ASCII',
    isBase32: 'Field must be Base32',
    isBase64: 'Field must be Base 64',
    isBefore: 'Error',
    isIBAN: 'Field must be IBAN',
    isBIC: 'Field must be BIC',
    isBoolean: 'Field must be BOOLEAN',
    isByteLength: 'Field has an incorrect byte length',
    isCreditCard: 'Field must be a credit card number',
    isCurrency: 'Field must be a valid currency',
    isEthereumAddress: 'Field must be a valid Ethereum Address',
    isBtcAddress: 'Field must be a valid BTC Address',
    isDataURI: 'Field must be a data URI',
    isDate: 'Field must be a date',
    isDecimal: 'Field must be a decimal',
    isDivisibleBy: 'Incorrect division',
    isEmail: 'Field must be an email',
    isEmpty: 'Field must be empty',
    isFloat: 'Field must be a floating point numbEr',
    isFQDN: 'Field must be a FQDN',
    isFullWidth: 'Error',
    isHalfWidth: 'Error',
    isHash: 'Field must be a hash',
    isHexadecimal: 'Field must be in hexadecimal',
    isHexColor: 'Field must be a HEX color',
    isHSL: 'Field must be a HSL color',
    isRgbColor: 'Field must be a RGB color',
    isIdentityCard: 'Field must be an identity card',
    isIn: 'Field is not an accepted value',
    isInt: 'Field must be an integer',
    isIP: 'Field must be an IP',
    isIPRange: 'Field must be an IP range',
    isISBN: 'Field must be an ISBN',
    isEAN: 'Field must be an EAN',
    isISIN: 'Field must be an ISIN',
    isISO31661Alpha2: 'Field must be in ISO31661Alpha2 format',
    isISO31661Alpha3: 'Field must be in ISO31661Alpha3 format',
    isISO8601: 'Field must be in ISO8601 format',
    isISSN: 'Field must be an ISSN',
    isISRC: 'Field must be an ISRC',
    isRFC3339: 'Field must be in RFC3339 format',
    isJSON: 'Field must be a valid JSON object',
    isJWT: 'Field must be a valid JWT',
    isLatLong: 'Field must be a valid latitude and longitude',
    isLength: 'Field is incorrect length',
    isLocale: 'Field must be a valid locale',
    isLowercase: 'Field must be in lowercase',
    isMACAddress: 'Field must be a valid MAC address',
    isMagnetURI: 'Field must be a valid Magnet URI',
    isMD5: 'Field must be a valid MD5 hash',
    isMimeType: 'Incorrect MIME type',
    isMongoId: 'Field must be a valid MongoID',
    isMultibyte: '',
    isNumeric: 'Field must be numeric',
    isOctal: 'Field must be octal',
    isPassportNumber: 'Field must be a valid passport number',
    isPort: 'Field must be a valid port number',
    isPostalCode: 'Field must be a valid postal code',
    isSemVer: 'Field must be a semantic version',
    isStrongPassword: 'Field must be a strong password',
    isSurrogatePair: 'Error',
    isURL: 'Field must be a valid URL',
    isUppercase: 'Field must be in UPPERCASE',
    isUUID: 'Field must be a valid UUID',
    isVariableWidth: '',
    isWhitelisted: 'Field must be in a list of approved values',
    matches: 'Field does not match',
    isSlug: 'Field must be a valid Slug',
    toBoolean: 'Error', //TODO
};
export function getMessage(key, config) {
    if (config && typeof config === 'object' && 'message' in config && config.message !== undefined) {
        if (IsValidReactNode(config.message)) {
            return config.message;
        }
        return null;
    }
    else {
        return DefaultMessages[key] || null;
    }
}
export function getConfigRuleValue(config) {
    if (config && typeof config === 'object' && 'value' in config) {
        return config.value;
    }
    else {
        return config;
    }
}
function getProperty(key, config) {
    if (config[key]) {
        return config[key];
    }
    else {
        return undefined;
    }
}
function optionalRule(value, result) {
    if (value === false) {
        return true;
    }
    else {
        return result;
    }
}
//# sourceMappingURL=ValidationRules.js.map